<mat-form-field class="wide-form-field">
  <mat-label>{{ label }}</mat-label>

  <mat-chip-grid #chipGrid aria-label="chips grid">
    @for (item of control.value; track $index) {
      <mat-chip-row
        (removed)="removeItem(item)"
        [editable]="true"
        (edited)="editItem(item, $event)"
        [aria-description]="'press enter to edit ' + item">
        {{ item }}

        <button matChipRemove [attr.aria-label]="'remove ' + item">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }

    <input
      matChipInputAddOnBlur
      [matChipInputFor]="chipGrid"
      [matChipInputSeparatorKeyCodes]="chipInputSeparatorCodes"
      (matChipInputTokenEnd)="addItem($event)" />
  </mat-chip-grid>
</mat-form-field>
